import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { 
  Home, 
  UserPlus, 
  CheckSquare, 
  Users, 
  Monitor, 
  BarChart3,
  Building
} from 'lucide-react';
import { cn } from '../../utils/cn';

const Navigation: React.FC = () => {
  const location = useLocation();

  const navItems = [
    {
      path: '/',
      label: 'Trang chủ',
      icon: Home,
      description: 'Tổng quan hệ thống'
    },
    {
      path: '/guest-registration',
      label: 'Đăng ký khách',
      icon: UserPlus,
      description: 'Kiosk đăng ký'
    },
    {
      path: '/approval',
      label: 'Duyệt đăng ký',
      icon: CheckSquare,
      description: 'BQL duyệt khách'
    },
    {
      path: '/reception',
      label: 'Lễ tân',
      icon: Users,
      description: 'Tra cứu & cấp thẻ'
    },
    {
      path: '/turnstile',
      label: 'Turnstile',
      icon: Monitor,
      description: 'Màn hình trụ'
    },
    {
      path: '/statistics',
      label: 'Thống kê',
      icon: BarChart3,
      description: 'Báo cáo & phân tích'
    }
  ];

  return (
    <div className="bg-white shadow-lg border-r border-secondary-200 w-64 min-h-screen">
      <div className="p-6">
        <div className="flex items-center space-x-3 mb-8">
          <div className="w-10 h-10 bg-primary-500 rounded-lg flex items-center justify-center">
            <Building className="w-6 h-6 text-white" />
          </div>
          <div>
            <h1 className="text-lg font-bold text-secondary-900">
              Tower Management
            </h1>
            <p className="text-sm text-secondary-500">
              Hệ thống quản lý ra vào
            </p>
          </div>
        </div>

        <nav className="space-y-2">
          {navItems.map((item) => {
            const Icon = item.icon;
            const isActive = location.pathname === item.path;
            
            return (
              <Link
                key={item.path}
                to={item.path}
                className={cn(
                  'flex items-center space-x-3 px-4 py-3 rounded-lg transition-colors group',
                  isActive
                    ? 'bg-primary-50 text-primary-700 border border-primary-200'
                    : 'text-secondary-600 hover:bg-secondary-50 hover:text-secondary-900'
                )}
              >
                <Icon className={cn(
                  'w-5 h-5',
                  isActive ? 'text-primary-600' : 'text-secondary-400 group-hover:text-secondary-600'
                )} />
                <div>
                  <div className="font-medium">{item.label}</div>
                  <div className="text-xs text-secondary-500">{item.description}</div>
                </div>
              </Link>
            );
          })}
        </nav>
      </div>
    </div>
  );
};

export default Navigation;
